import { animated, useTransition } from 'react-spring';
import { GrowProps } from './grow-props';
import React from 'react';
import { cx } from '@mint/core';

const ROOT_CLASS_NAME = 'grow';

const GrowAnimation = animated('div');
GrowAnimation.displayName = 'GrowAnimation';

export const Grow = React.forwardRef<HTMLDivElement, GrowProps>(
  (props, ref): React.ReactElement => {
    const { children, className, in: animIn, style, ...rest } = props;

    const transitions = useTransition(animIn, null, {
      enter: { opacity: 1, transform: 'scale(0.999, 0.999) translateZ(0)' },
      from: { opacity: 0, transform: 'scale(0.8, 0.8) translateZ(0)' },
      leave: { opacity: 0, transform: 'scale(0.8, 0.8) translateZ(0)' },
      config: { friction: 55, tension: 700 },
    });

    return transitions.map(
      ({ item, key, props }): React.ReactElement | false =>
        item && (
          <GrowAnimation
            className={cx(ROOT_CLASS_NAME, className)}
            key={key}
            {...rest}
            style={{
              backfaceVisibility: 'hidden',
              perspective: '1px',
              ...style,
              ...props,
            }}
            ref={ref}
          >
            {children}
          </GrowAnimation>
        ),
    ) as any;
  },
);

Grow.displayName = 'Grow';
